import React from 'react';
import { StyleSheet, ScrollView, KeyboardAvoidingView, Platform } from 'react-native';
import { BaseAdminScreen } from '@/components';
import { AdminStackParamList } from '@/navigation/admin/AdminNavigator';
import { ADMIN_COLORS } from '@/constants/admin';
import { ActionButtons } from '@/components';

interface MobileFormScreenProps {
  screenName: keyof AdminStackParamList;
  navigation: any;
  isSubmitting?: boolean;
  submitText?: string;
  onSubmit: () => void;
  onCancel: () => void;
  children: React.ReactNode;
}

export const MobileFormScreen: React.FC<MobileFormScreenProps> = ({
  screenName,
  navigation,
  isSubmitting,
  submitText = 'Save',
  onSubmit,
  onCancel,
  children,
}) => {
  return (
    <BaseAdminScreen
      screenName={screenName}
      navigation={navigation}
      showPlaceholder={false}
      scrollEnabled={false}
      contentContainerStyle={styles.baseScreenContent}
    >
      <KeyboardAvoidingView
        style={styles.container}
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      >
        <ScrollView
          style={styles.scrollView}
          contentContainerStyle={styles.scrollContent}
          showsVerticalScrollIndicator={false}
          keyboardShouldPersistTaps="handled"
        >
          {children}
        </ScrollView>

        <ActionButtons
          isLoading={!!isSubmitting}
          onCancel={onCancel}
          onSubmit={onSubmit}
          submitText={submitText}
        />
      </KeyboardAvoidingView>
    </BaseAdminScreen>
  );
};

const styles = StyleSheet.create({
  baseScreenContent: {
    paddingHorizontal: 0,
    paddingTop: 0,
    paddingBottom: 20,
    flexGrow: 1,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
    borderTopWidth: 1,
    borderTopColor: ADMIN_COLORS.BORDER,
  },
  container: {
    flex: 1,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    padding: 16,
    paddingBottom: 100,
  },
});


